import React, { useState,useRef,useContext,useEffect } from 'react';
// import { Route, Routes, useLocation, NavLink } from 'react-router-dom';
import { useUserAPI } from '../../components/useUserAPI';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
import Slider from 'react-slick';
// import { iAeonMiniApp } from '../../library/iaeon_sdk_240405';
// import * as IaeonSdk from './library/iaeon_sdk.js';
import { iAeonGetData } from '../../library/iaeon_sdk.js';
import { iAeonGetLocation } from '../../library/iaeon_sdk.js';

//お買物API
import { callOkaimonoAPI } from "../../components/okaimonoAPI";

// import "../assets/slick.css";
// import "../assets/slick-theme.css";
// CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// @import '~slick-carousel/slick/slick';
// @import '~slick-carousel/slick/slick-theme';

import styles from '../../styles/Intro.module.scss'


// import React, { useContext } from 'react';
// import DeviceContext from '../../components/DeviceContext';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function Intro(props) {


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	// document.documentElement.classList.add('is_fixed');
	// document.body.classList.add('is_fixed');
	// document.getElementById('header').classList.remove('is_behind');
	// document.getElementById('header').classList.add('is_fixed');

	var elements = document.getElementsByClassName('header_logo');
	Array.from(elements).forEach(function(element) {
		element.classList.remove('is_hide');
	});

	let zratio = window.innerWidth / 390;
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('introBox');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
}, []);


useEffect(() => {
	//お買物API：画面遷移API（利用方法
	props.okaimonoAPI_didScreenTransition("how_to_use");
}, []);


//----------------------------------------
//vars
//----------------------------------------

const settings = {
	autoplay: false,
	speed: 600,
	dots: true,
	infinite: false,
	arrows: false,
	draggable: true,
	mobileFirst: true,
	// initialSlide: 0,
	touchThreshold: 50,
	verticalSwiping: false,
	slidesToShow: 1,
	centerMode: false,
	// variableWidth: true,
	slidesToScroll: 1
}
// const { os, browser, device } = useContext(DeviceContext);

const sliderRef = useRef();

const sharedInfo = useContext(SharedInfoContext);
const { token, updateToken } = useContext(SharedInfoContext);
const { bandColor, updateBandColor } = useContext(SharedInfoContext);
const { transactionno, updateTransactionno} = useContext(SharedInfoContext);
const { glocation, updategLocation } = useContext(SharedInfoContext);
const { dammingCheckRunInterval, updateDammingCheckRunInterval } = useContext(SharedInfoContext);


//----------------------------------------
//スタート画面に戻る
//----------------------------------------

const BackHome = () => {
	props.setPage("home")
	// se08_se();
	props.setSoundState("se08_se");
}


//----------------------------------------
// iAEON API：19.データ取得API（買物データ復元
//----------------------------------------

function callAPI_19(){
	console.log("----------------------------");
	console.log("【iAeonGetData】post");
    let successCall_19 = function(success){
        var aaa = JSON.stringify(success);
		// var jsonString = success.replace(/”}$/, '"}}');
		// var aaa = JSON.perse(jsonString);
		console.log('【iAeonGetData】success：' + aaa);
        var bbb = JSON.parse(aaa);
		console.log('【iAeonGetData】bbb：');
		console.log(bbb);
        var ccc = JSON.parse(bbb.value);
		console.log('【iAeonGetData】ccc：');
		console.log(ccc);
		console.log('【iAeonGetData】transactionno：' + ccc.transactionno);
		console.log('【iAeonGetData】date：' + ccc.date);
		console.log('【iAeonGetData】storeCode：' + ccc.storeCode);
		// console.log('【iAeonGetData】bandColor：' + ccc.bandColor);

		// 現在の日付と時刻を取得
		const todays = new Date();
		// 日付を YYYY-MM-DD 形式で表示
		const dateToday = todays.toISOString().split('T')[0];
		console.log("本日の日付: "+dateToday);

		if(ccc.transactionno !== null && ccc.transactionno !== "undefined" && ccc.transactionno !== undefined){
			console.log("【iAeonGetData】買物データあり");
			if(dateToday === ccc.date){ //日付一致
				console.log("【iAeonGetData】日付一致");
				if(sharedInfo.storeCode === ccc.storeCode){ //店舗ID一致
					console.log("【iAeonGetData】店舗ID一致 → 買物復元");

					updateTransactionno(ccc.transactionno);
					props.setErrFlg(true);
					props.setErr([true,`shopping_recovery`,`;;;;;`]);

				}else {
					console.log("【iAeonGetData】店舗ID一致せず 復元なし 買物開始");

					if(process.env.REACT_APP_GPS === "true"){ //GPS有効
						console.log("GPS有効");
						//12.位置情報取得API
						// callAPI_12_checkin(false);
						//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
						okaimonoAPI_getDeviceLocation_checkin(false);

					}else{ //GPS無効
						console.log("GPS無効");
						//イオンスタイル千葉みなと 0000052160
						var newLocation = "35.600458, 140.113616";
						storecheckinAPI(newLocation,sharedInfo.storeCode);
					}
				}
			}else {
				console.log("【iAeonGetData】日付一致せず 復元なし 買物開始");

				if(process.env.REACT_APP_GPS === "true"){ //GPS有効
					console.log("GPS有効");
					//12.位置情報取得API
					// callAPI_12_checkin(false);
					//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
					okaimonoAPI_getDeviceLocation_checkin(false);

				}else{ //GPS無効
					console.log("GPS無効");
					//イオンスタイル千葉みなと 0000052160
					var newLocation = "35.600458, 140.113616";
					storecheckinAPI(newLocation,sharedInfo.storeCode);
				}
			}
		}else{
			console.log("【iAeonGetData】買物データなし 復元なし 買物開始");

			if(process.env.REACT_APP_GPS === "true"){ //GPS有効
				console.log("GPS有効");
				//12.位置情報取得API
				// callAPI_12_checkin(false);
				//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
				okaimonoAPI_getDeviceLocation_checkin(false);

			}else{ //GPS無効
				console.log("GPS無効");
				//イオンスタイル千葉みなと 0000052160
				var newLocation = "35.600458, 140.113616";
				storecheckinAPI(newLocation,sharedInfo.storeCode);
			}
		}
    }
    let errorCall_19 = function(error){
        var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetData】error：' + bbb);
		console.log("【iAeonGetData】買物データなし 復元なし 買物開始");

		if(process.env.REACT_APP_GPS === "true"){ //GPS有効
			console.log("GPS有効");
			//12.位置情報取得API
			// callAPI_12_checkin(false);
			//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
			okaimonoAPI_getDeviceLocation_checkin(false);

		}else{ //GPS無効
			console.log("GPS無効");
			//イオンスタイル千葉みなと 0000052160
			var newLocation = "35.600458, 140.113616";
			storecheckinAPI(newLocation,sharedInfo.storeCode);
		}
    }
    iAeonGetData({"key": "shopping_data"}).then(successCall_19).catch(errorCall_19);
}


//----------------------------------------
//お買物API：データ取得API（買物データ復元 << 19.データ取得API（買物データ復元
//----------------------------------------

const okaimonoAPI_getShoppingData = async () => {
	try {
		console.log("----------------------------");
		console.log("【loadTransactionData:shopping_data】call");
		const { callbackId, result } = await callOkaimonoAPI('loadTransactionData', { key: 'shopping_data' });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【loadTransactionData:shopping_data】success", result);
			console.log("【loadTransactionData:shopping_data】result:", result.result);
			console.log("【loadTransactionData:shopping_data】value:", result.value);

			var ccc = JSON.parse(result.value);
			console.log('【loadTransactionData:shopping_data】ccc：');
			console.log(ccc);
			console.log('【loadTransactionData:shopping_data】transactionno：' + ccc.transactionno);
			console.log('【loadTransactionData:shopping_data】date：' + ccc.date);
			console.log('【loadTransactionData:shopping_data】storeCode：' + ccc.storeCode);

			// 現在の日付と時刻を取得
			const todays = new Date();
			// 日付を YYYY-MM-DD 形式で表示：本番
			const dateToday = todays.toISOString().split('T')[0];
			// 日付を YYYY-MM-DD 形式で表示：ダミー対応
			// const dateToday = "2024-07-16";
			console.log("本日の日付: "+dateToday);

			if(ccc.transactionno !== null && ccc.transactionno !== "undefined" && ccc.transactionno !== undefined){
				console.log("【loadTransactionData:shopping_data】買物データあり");
				if(dateToday === ccc.date){ //日付一致
					console.log("【loadTransactionData:shopping_data】日付一致");
					if(sharedInfo.storeCode === ccc.storeCode){ //店舗ID一致
						console.log("【loadTransactionData:shopping_data】店舗ID一致 → 買物復元");

						updateTransactionno(ccc.transactionno);
						props.setErrFlg(true);
						props.setErr([true,`shopping_recovery`,`;;;;;`]);

					}else {
						console.log("【loadTransactionData:shopping_data】店舗ID一致せず 復元なし 買物開始");

						if(process.env.REACT_APP_GPS === "true"){ //GPS有効
							console.log("GPS有効");
							//12.位置情報取得API
							// callAPI_12_checkin(false);
							//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
							okaimonoAPI_getDeviceLocation_checkin(false);

						}else{ //GPS無効
							console.log("GPS無効");
							//イオンスタイル千葉みなと 0000052160
							var newLocation = "35.600458, 140.113616";
							storecheckinAPI(newLocation,sharedInfo.storeCode);
						}
					}
				}else {
					console.log("【loadTransactionData:shopping_data】日付一致せず 復元なし 買物開始");

					if(process.env.REACT_APP_GPS === "true"){ //GPS有効
						console.log("GPS有効");
						//12.位置情報取得API
						// callAPI_12_checkin(false);
						//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
						okaimonoAPI_getDeviceLocation_checkin(false);

					}else{ //GPS無効
						console.log("GPS無効");
						//イオンスタイル千葉みなと 0000052160
						var newLocation = "35.600458, 140.113616";
						storecheckinAPI(newLocation,sharedInfo.storeCode);
					}
				}
			}else{
				console.log("【loadTransactionData:shopping_data】買物データなし 復元なし 買物開始");

				if(process.env.REACT_APP_GPS === "true"){ //GPS有効
					console.log("GPS有効");
					//12.位置情報取得API
					// callAPI_12_checkin(false);
					//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
					okaimonoAPI_getDeviceLocation_checkin(false);

				}else{ //GPS無効
					console.log("GPS無効");
					//イオンスタイル千葉みなと 0000052160
					var newLocation = "35.600458, 140.113616";
					storecheckinAPI(newLocation,sharedInfo.storeCode);
				}
			}

		}else {
			console.log("【loadTransactionData:shopping_data】error", result);
			console.log("【loadTransactionData:shopping_data】result:", result.result);
			console.log("【loadTransactionData:shopping_data】買物データなし 復元なし 買物開始");

			if(process.env.REACT_APP_GPS === "true"){ //GPS有効
				console.log("GPS有効");
				//12.位置情報取得API
				// callAPI_12_checkin(false);
				//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
				okaimonoAPI_getDeviceLocation_checkin(false);

			}else{ //GPS無効
				console.log("GPS無効");
				//イオンスタイル千葉みなと 0000052160
				var newLocation = "35.600458, 140.113616";
				storecheckinAPI(newLocation,sharedInfo.storeCode);
			}
		}

	} catch (error) {
		// console.error("APIエラー:", error);
		// console.log('【loadTransactionData:policy_data】error：: ' + error.error_code + " : " + error.message);
		console.log("【loadTransactionData:shopping_data】error", error);
		console.log("【loadTransactionData:shopping_data】買物データなし 復元なし 買物開始");

		if(process.env.REACT_APP_GPS === "true"){ //GPS有効
			console.log("GPS有効");
			//12.位置情報取得API
			// callAPI_12_checkin(false);
			//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
			okaimonoAPI_getDeviceLocation_checkin(false);

		}else{ //GPS無効
			console.log("GPS無効");
			//イオンスタイル千葉みなと 0000052160
			var newLocation = "35.600458, 140.113616";
			storecheckinAPI(newLocation,sharedInfo.storeCode);
		}
	}
};


//----------------------------------------
// iAEON API：12.位置情報取得API（チェックイン
//----------------------------------------

function callAPI_12_checkin(recoverFlg){
	//仮対応
	// let pos = "35.600458, 140.113616";
	// updategLocation(pos);
		// if(recoverFlg === true){
		// 	recoveryAPI(sharedInfo.transactionno,sharedInfo.storeCode);
		// }else{
		// 	var newLocation = "35.600458, 140.113616";
		// 	storecheckinAPI(newLocation,sharedInfo.storeCode);
		// }
	// setRecoveryState(recoverFlg);
	// var newLocation = "35.600458, 140.113616";
	// storecheckinAPI(newLocation,sharedInfo.storeCode);

	//本対応
    let successCall_12 = function(success){
        var aaa = success;
		console.log('【iAeonGetLocation】success：' + aaa);
		console.log('【iAeonGetLocation】latitude：' + aaa.latitude);
		console.log('【iAeonGetLocation】longtitude：' + aaa.longtitude);
		let pos = aaa.latitude + ", " + aaa.longtitude;
		updategLocation(pos);
		// if(recoverFlg === true){
		// 	recoveryAPI(sharedInfo.transactionno,sharedInfo.storeCode);
		// }else{
		// 	var newLocation = aaa.latitude + ", " + aaa.longtitude;
		// 	storecheckinAPI(newLocation,sharedInfo.storeCode);
		// }
		setRecoveryState(recoverFlg);
		if(process.env.REACT_APP_GPS === "true"){ //GPS有効
			console.log("GPS有効");
			var newLocation = aaa.latitude + ", " + aaa.longtitude;
			storecheckinAPI(newLocation,sharedInfo.storeCode);
		}else{ //GPS無効
			var newLocation = "35.600458, 140.113616";
			storecheckinAPI(newLocation,sharedInfo.storeCode);
		}
    }
    let errorCall_12 = function(error){
		var bbb = error;
		console.log('【iAeonGetLocation】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
    }
	console.log('【iAeonGetLocation】call');
    iAeonGetLocation().then(successCall_12).catch(errorCall_12);
}


//----------------------------------------
//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
//----------------------------------------

const [recoveryState, setRecoveryState] = useState(false);

const okaimonoAPI_getDeviceLocation_checkin = async (recoverFlg) => {
	try {
		console.log("----------------------------");
		console.log("【getDeviceLocation(checkin)】call");
		const { callbackId, result } = await callOkaimonoAPI('getDeviceLocation');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【getDeviceLocation(checkin)】success", result);
			console.log("【getDeviceLocation(checkin)】result:", result.result);
			console.log("【getDeviceLocation(checkin)】latitude:", result.latitude);
			// console.log("【getDeviceLocation(checkin)】longtitude:", result.longtitude);
			console.log("【getDeviceLocation(checkin)】longitude:", result.longitude);

			// let pos = result.latitude + ", " + result.longtitude;
			let pos = result.latitude + ", " + result.longitude;
			updategLocation(pos);
			setRecoveryState(recoverFlg);
			if(process.env.REACT_APP_GPS === "true"){ //GPS有効
				console.log("GPS有効");
				// var newLocation = result.latitude + ", " + result.longtitude;
				var newLocation = result.latitude + ", " + result.longitude;
				storecheckinAPI(newLocation,sharedInfo.storeCode);
			}else{ //GPS無効
				var newLocation = "35.600458, 140.113616";
				storecheckinAPI(newLocation,sharedInfo.storeCode);
			}

		}else {
			console.log("【getDeviceLocation(checkin)】error", result);
			console.log("【getDeviceLocation(checkin)】result:", result.result);
			console.log("【getDeviceLocation(checkin)】code:", result.error.code);
			console.log("【getDeviceLocation(checkin)】message:", result.error.message);
			props.setErrFlg(true);
			var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			props.setErr([true, result.error.code, error_msg]);
		}

	} catch (error) {
		console.log('【getDeviceLocation(checkin)】error', error);
		props.setErrFlg(true);
		props.setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};

useEffect(() => {
	if(props.recoveryChoice === true){
		console.log("【getDeviceLocation(checkin)】店舗ID一致 → 買物復元");
		// callAPI_12_checkin(true);
		//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
		okaimonoAPI_getDeviceLocation_checkin(true);

	}else if(props.recoveryChoice === false){
		console.log("【getDeviceLocation(checkin)】買物データなし 復元なし 買物開始");

		if(process.env.REACT_APP_GPS === "true"){ //GPS有効
			console.log("GPS有効");
			//12.位置情報取得API
			// callAPI_12_checkin(false);
			//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
			okaimonoAPI_getDeviceLocation_checkin(false);

		}else{ //GPS無効
			console.log("GPS無効");
			//イオンスタイル千葉みなと 0000052160
			var newLocation = "35.600458, 140.113616";
			storecheckinAPI(newLocation,sharedInfo.storeCode);
		}
	}
}, [props.recoveryChoice]);


//----------------------------------------
//買物開始
//----------------------------------------

const StartShopping = () => {
	if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
		console.log("REACT_APP_OKAIMONO_FLG: " + process.env.REACT_APP_OKAIMONO_FLG);
		console.log("OKAIMONO 有効：買物データ確認");
		// callAPI_19();
		//お買物API：データ取得API（買物データ復元 << 19.データ取得API（買物データ復元
		okaimonoAPI_getShoppingData();

	}else if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
		console.log("iAEON 有効：買物データ確認");
		callAPI_19();

	}else{ //iAEON無効
		console.log("iAEON 無効：買物開始");

		if(process.env.REACT_APP_GPS === "true"){ //GPS有効
			console.log("GPS有効");
			//12.位置情報取得API
			// callAPI_12_checkin(false);
			//お買物API：位置情報取得API（チェックイン << 12.位置情報取得API（チェックイン
			okaimonoAPI_getDeviceLocation_checkin(false);

		}else{ //GPS無効
			console.log("GPS無効");
			//イオンスタイル幕張新都心フードストア 0000082900
			// var newLocation = "35.656429, 140.027035";
			//イオンスタイル千葉みなと 0000052160
			var newLocation = "35.600458, 140.113616";
			storecheckinAPI(newLocation,sharedInfo.storeCode);
		}
	}
	// se08_se();
	props.setSoundState("se08_se");
}


//----------------------------------------
//店舗チェックインAPI：レスポンス
//----------------------------------------

const { storecheckinAPI, data: storecheckinData, loading: storecheckinLoading, error: storecheckinError } = useUserAPI();

useEffect(() => {
	if(storecheckinData){
		if (storecheckinData.data) { //SUCCESS
			console.log(`【storecheckinAPI】 storeCheckInFlag: ${storecheckinData.data.storeCheckInFlag}`);

			if(storecheckinData.data.storeCheckInFlag === "1"){ //店舗チェックインOK
				console.log("【storecheckinAPI】 店舗チェックイン: OK");
				console.log("買物復元あり → recoveryAPI");
				if(recoveryState === true && process.env.REACT_APP_OKAIMONO_FLG === "true"){ //買物復元あり
					recoveryAPI(sharedInfo.transactionno,sharedInfo.storeCode);

				}else if(recoveryState === true && process.env.REACT_APP_IAEON_FLG === "true"){ //買物復元あり
					recoveryAPI(sharedInfo.transactionno,sharedInfo.storeCode);

				}else{ //買物復元なし
					console.log("買物復元なし → shoppingStartAPI");
					shoppingStartAPI(sharedInfo.storeCode);
				}
			}else{ //店舗チェックインNG
				console.log("【storecheckinAPI】 店舗チェックイン: NG");
				props.setErrFlg(true);
				props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_CHECKIN]);
				// props.setErr([true,``,`;チェックインエラー;レジゴー有効範囲から離れています。300m以内に移動して再度お試しください。;;;`]);
			}
		}else{ //ERROR
			console.log(`【storecheckinAPI】 errorCode: ${storecheckinData.errorCode}`);
			console.log(`【storecheckinAPI】 errorMessage: ${storecheckinData.errorMessage}`);
			console.log(`【storecheckinAPI】 isSuccess: ${storecheckinData.isSuccess}`);

			// props.setErrNum(`${shoppingStartData.errorCode}`);
			// props.setShowModal(true);
			// props.setErrTxt(`${shoppingStartData.errorMessage}`);
			props.setErrFlg(true);
			props.setErr([true,`${storecheckinData.errorCode}`,`${storecheckinData.errorMessage}`]);
		}
	}
	if(storecheckinError){
		console.log("storecheckinError");
		console.log(storecheckinError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(storecheckinLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [storecheckinData,storecheckinLoading,storecheckinError]);


//----------------------------------------
//買物開始API：レスポンス
//----------------------------------------

const { shoppingStartAPI, data: shoppingStartData, loading: shoppingStartLoading, error: shoppingStartError } = useUserAPI();

useEffect(() => {
	if(shoppingStartData){
		if (shoppingStartData.data) { //SUCCESS
			console.log(`【shoppingStartAPI】 transactionno: ${shoppingStartData.data.transactionno}`);
			console.log(`【shoppingStartAPI】 token: ${shoppingStartData.data.token}`);
			console.log(`【shoppingStartAPI】 bandColor: ${shoppingStartData.data.bandColor}`);
			console.log(`【shoppingStartAPI】 runInterval: ${shoppingStartData.data.runInterval}`);
			console.log(`【shoppingStartAPI】 bonusFlag: ${shoppingStartData.data.bonusFlag}`);
			console.log(`【shoppingStartAPI】 lotteryFlag: ${shoppingStartData.data.lotteryFlag}`);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				console.log(`【shoppingStartAPI】 dammingCheckRunInterval: ${shoppingStartData.data.dammingCheckRunInterval}`);
			}

			// if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
			// 	callAPI_18(shoppingStartData.data.transactionno);
			// }

			if(shoppingStartData.data.bandColor === "#A1C237"){ //日
				updateBandColor("bandcol01_SUNDAY");
			}else if(shoppingStartData.data.bandColor === "#CE57AF"){ //月
				updateBandColor("bandcol02_MONDAY");
			}else if(shoppingStartData.data.bandColor === "#C93A40"){ //火
				updateBandColor("bandcol03_TUESDAY");
			}else if(shoppingStartData.data.bandColor === "#00A0F0"){ //水
				updateBandColor("bandcol04_WEDNESDAY");
			}else if(shoppingStartData.data.bandColor === "#FFB42D"){ //木
				updateBandColor("bandcol05_THURSDAY");
			}else if(shoppingStartData.data.bandColor === "#00A546"){ //金
				updateBandColor("bandcol06_FRIDAY");
			}else if(shoppingStartData.data.bandColor === "#B60081"){ //土
				updateBandColor("bandcol07_SATURDAY");
			}

			updateTransactionno(shoppingStartData.data.transactionno);
			updateToken(shoppingStartData.data.token);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				updateDammingCheckRunInterval(shoppingStartData.data.dammingCheckRunInterval);
			}

			// if(sharedInfo.storeInfo.attentionkagoUrl.attentionkagoImgAndroidJ === null){ //アテンション画像なし
			// 	document.getElementById('header').classList.remove('is_hide');
			// 	document.getElementById('header').classList.add('is_behind');
			// 	document.getElementById('header').classList.add('is_fixed');
			// 	props.setPage("shopping");
			// }else{ //アテンション画像あり
			// 	props.setPage("attention");
			// }

			//お買物API：新規取引開始通知API
			props.okaimonoAPI_didNewTransaction(sharedInfo.storeCode);

			//アテンション画像なし
			document.getElementById('header').classList.remove('is_hide');
			document.getElementById('header').classList.add('is_behind');
			document.getElementById('header').classList.add('is_fixed');
			props.setPage("shopping");

			props.setShoppingStData(shoppingStartData);
		}else{ //ERROR
			console.log(`【shoppingStartAPI】 errorCode: ${shoppingStartData.errorCode}`);
			console.log(`【shoppingStartAPI】 errorMessage: ${shoppingStartData.errorMessage}`);
			console.log(`【shoppingStartAPI】 isSuccess: ${shoppingStartData.isSuccess}`);

			// props.setErrNum(`${shoppingStartData.errorCode}`);
			// props.setShowModal(true);
			// props.setErrTxt(`${shoppingStartData.errorMessage}`);
			props.setErrFlg(true);
			props.setErr([true,`${shoppingStartData.errorCode}`,`${shoppingStartData.errorMessage}`]);
		}
	}
	if(shoppingStartError){
		console.log("shoppingStartError");
		console.log(shoppingStartError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(shoppingStartLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [shoppingStartData,shoppingStartLoading,shoppingStartError]);


//----------------------------------------
//取引復旧API：レスポンス
//----------------------------------------

const { recoveryAPI, data: recoveryData, loading: recoveryLoading, error: recoveryError } = useUserAPI();

useEffect(() => {
	if(recoveryData){
		if (recoveryData.data) { //SUCCESS
			console.log("【recoveryAPI】recoveryData:");
			console.log(recoveryData);
			console.log(`【recoveryAPI】 transactionno: ${recoveryData.data.transactionno}`);
			console.log(`【recoveryAPI】 token: ${recoveryData.data.token}`);
			console.log(`【recoveryAPI】 bandColor: ${recoveryData.data.bandColor}`);
			console.log(`【recoveryAPI】 runInterval: ${recoveryData.data.runInterval}`);
			console.log(`【recoveryAPI】 bonusFlag: ${recoveryData.data.bonusFlag}`);
			console.log(`【recoveryAPI】 lotteryFlag: ${recoveryData.data.lotteryFlag}`);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				console.log(`【recoveryAPI】 dammingCheckRunInterval: ${recoveryData.data.dammingCheckRunInterval}`);
			}

			// callAPI_18(recoveryData.data.transactionno);

			if(recoveryData.data.bandColor === "#A1C237"){ //日
				updateBandColor("bandcol01_SUNDAY");
			}else if(recoveryData.data.bandColor === "#CE57AF"){ //月
				updateBandColor("bandcol02_MONDAY");
			}else if(recoveryData.data.bandColor === "#C93A40"){ //火
				updateBandColor("bandcol03_TUESDAY");
			}else if(recoveryData.data.bandColor === "#00A0F0"){ //水
				updateBandColor("bandcol04_WEDNESDAY");
			}else if(recoveryData.data.bandColor === "#FFB42D"){ //木
				updateBandColor("bandcol05_THURSDAY");
			}else if(recoveryData.data.bandColor === "#00A546"){ //金
				updateBandColor("bandcol06_FRIDAY");
			}else if(recoveryData.data.bandColor === "#B60081"){ //土
				updateBandColor("bandcol07_SATURDAY");
			}

			updateTransactionno(recoveryData.data.transactionno);
			updateToken(recoveryData.data.token);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				updateDammingCheckRunInterval(recoveryData.data.dammingCheckRunInterval);
			}

			// if(sharedInfo.storeInfo.attentionkagoUrl.attentionkagoImgAndroidJ === null){ //アテンション画像なし
			// 	document.getElementById('header').classList.remove('is_hide');
			// 	document.getElementById('header').classList.add('is_behind');
			// 	document.getElementById('header').classList.add('is_fixed');
			// 	props.setPage("shopping");
			// }else{ //アテンション画像あり
			// 	props.setPage("attention");
			// }

			//アテンション画像なし
			document.getElementById('header').classList.remove('is_hide');
			document.getElementById('header').classList.add('is_behind');
			document.getElementById('header').classList.add('is_fixed');
			props.setPage("shopping");

			props.setShoppingStData(recoveryData);
			props.setShoppingData(recoveryData);
		}else{ //ERROR
			console.log(`【shoppingStartAPI】 errorCode: ${recoveryData.errorCode}`);
			console.log(`【shoppingStartAPI】 errorMessage: ${recoveryData.errorMessage}`);
			console.log(`【shoppingStartAPI】 isSuccess: ${recoveryData.isSuccess}`);

			// props.setErrNum(`${shoppingStartData.errorCode}`);
			// props.setShowModal(true);
			// props.setErrTxt(`${shoppingStartData.errorMessage}`);
			props.setErrFlg(true);
			props.setErr([true,`${recoveryData.errorCode}`,`${recoveryData.errorMessage}`]);
		}
	}
	if(recoveryError){
		console.log("shoppingStartError");
		console.log(recoveryError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(recoveryLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [recoveryData,recoveryLoading,recoveryError]);



return (
	<>
	{/* <div id="contents" className="container l_contents bg_white"> */}

<div id="introBox" className={styles.introBox}>
	<Slider {...settings} ref={sliderRef} className={styles.introSlider}>
		<div className={styles.introSlider_box}>
			<div className={styles.introSlider_info}>
				<h2 className={styles.step_num}>
					<img src="/images/howto_step01.svg" alt="ステップ1" width="48" height="66"/>
					{/* <Image
						src="/images/howto_step01.svg"
						alt="ステップ1"
						width={35}
						height={48}
					/> */}
				</h2>
				<figure className={styles.introSlider_img}>
					<img src="/images/howto_step01_img.svg" alt="" width="238" height="149"/>
					{/* <Image
						src="/images/howto_step01_img.svg"
						alt=""
						width={238}
						height={149}
					/> */}
				</figure>
				<p className={styles.introSlider_txt}>お買い上げする商品の<br/>バーコードをスキャン</p>
			</div>
			{/* <figure className="introSlider_img">
				<Image
					src="/images/walkthrough_img01.png"
					alt=""
					width={600}
					height={600}
				/>
			</figure>
			<p className="introSlider_txt">利用店舗の近くで<br/>アプリを起動しチェックイン</p> */}
		</div>
		<div className={styles.introSlider_box}>
			<h2 className={styles.step_num}>
				<img src="/images/howto_step02.svg" alt="ステップ2" width="48" height="66"/>
				{/* <Image
					src="/images/howto_step02.svg"
					alt="ステップ2"
					width={35}
					height={48}
				/> */}
			</h2>
			<figure className={`${styles.introSlider_img} ${styles.introSlider_img02}`}>
				<img src="/images/howto_step02_img.svg" alt="" width="231" height="151"/>
				{/* <Image
					src="/images/howto_step02_img.svg"
					alt=""
					width={231}
					height={151}
				/> */}
			</figure>
			<p className={styles.introSlider_txt}>お支払いコードを<br/>スキャンしてお会計<br/>
			<small>※お買い物の内容を確認させていただくことがあります。</small></p>
			{/* <figure className="introSlider_img">
				<Image
					src="/images/walkthrough_img02.png"
					alt=""
					width={600}
					height={600}
				/>
			</figure>
			<p className="introSlider_txt">商品のバーコードを<br/>スマホでスキャン</p>
			<button className="commonBtn01 introSlider_nextBtn" onClick={onSlickNext}>次へ</button>
			<button className="commonBtn04 introSlider_startBtn" onClick={StartShopping}>利用を始める</button> */}
		</div>
		<div className={styles.introSlider_box}>
			<h2 className={styles.step_num}>
				<img src="/images/howto_step03.svg" alt="ステップ3" width="48" height="66"/>
				{/* <Image
					src="/images/howto_step03.svg"
					alt="ステップ3"
					width={35}
					height={48}
				/> */}
			</h2>
			<figure className={`${styles.introSlider_img} ${styles.introSlider_img03}`}>
				<img src="/images/howto_step03_img.svg" alt="" width="212" height="146"/>
				{/* <Image
					src="/images/howto_step03_img.svg"
					alt=""
					width={280}
					height={280}
				/> */}
			</figure>
			<p className={`${styles.introSlider_txt} ${styles.introSlider_txt02}`}>スマホに表示されるコードを<br/>ゲート画面にかざして完了</p>
			{/* <figure className="introSlider_img">
				<Image
					src="/images/walkthrough_img03.png"
					alt=""
					width={600}
					height={600}
				/>
			</figure>
			<p className="introSlider_txt">レジにある<br/>QRコードをスキャン</p>
			<button className="commonBtn01 introSlider_nextBtn" onClick={onSlickNext}>次へ</button>
			<button className="commonBtn04 introSlider_startBtn" onClick={StartShopping}>利用を始める</button> */}
		</div>
	</Slider>
	{/* <button className="commonBtn01 introSlider_startBtn" onClick={StartShopping}>利用を始める</button> */}
	<div className={`${styles.commonBtn01} ${styles.introSlider_startBtn} ${props.activeStore ? '' : styles.is_disabled}`} onClick={StartShopping}><span>お買い物をはじめる</span></div>
	<div className={`${styles.commonBtn04} ${styles.introSlider_backBtn}`} onClick={BackHome}>スタート画面に戻る</div>
	{/* <NavLink to="/shopping" className={`${styles.commonBtn01} ${styles.introSlider_startBtn}`} onClick={StartShopping}>お買い物をはじめる</NavLink> */}
</div>
</>
)

}
